module.exports = __webpack_public_path__ + "img/buy_now.3af2b0fa.png";